var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('p',{staticClass:"title"},[_c('span',[_vm._v("一")]),_c('span',[_vm._v("切")]),_c('span',[_vm._v("就")]),_c('span',[_vm._v("绪")])]),_c('p',{staticClass:"child"},[_vm._v("将带你开启智会之旅")])])
}]

export { render, staticRenderFns }